export default [
    [{ display: "ROYAL FLUSH", pokersolver: "Royal Flush"}, 250, 500, 750, 1000, 4000],
    [{ display: "STRAIGHT FLUSH", pokersolver: "Straight Flush"}, 50, 100, 150, 200, 250],
    [{ display: "FOUR OF A KIND", pokersolver: "Four of a Kind"}, 25, 50, 75, 100, 125],
    [{ display: "FULL HOUSE", pokersolver: "Full House"}, 9, 18, 27, 36, 45],
    [{ display: "FLUSH", pokersolver: "Flush"}, 6, 12, 18, 24, 30],
    [{ display: "STRAIGHT", pokersolver: "Straight"}, 4, 8, 12, 16, 20],
    [{ display: "THREE OF A KIND", pokersolver: "Three of a Kind"}, 3, 6, 9, 12, 15],
    [{ display: "TWO PAIR", pokersolver: "Two Pair"}, 2, 4, 6, 8, 10],
    [{ display: "JACKS OR BETTER", pokersolver: "Jacks or Better"}, 1, 2, 3, 4, 5]
];